import React from "react";
import styled from "@emotion/styled";
import {useTheme} from "@emotion/react";
import {getImageUrl} from "../../../context/ApplicationContextProvider";

const CourseClearModal = (props) => {
    // Dialog Context
    const dialog_utils = props.dialog_utils || {};
    const dialog_props = props.dialog_props || {};

    // css style
    const {view} = useComponentStyle();

    const onCloseModal = () => {
        dialog_utils.hideDialog && dialog_utils.hideDialog(dialog_props.id);
    };

    return (
        <view.ModalSection onClick={onCloseModal}>
            <view.ModalWrapper>
                <view.ModalTitle>
                    <h3>모든 강의를 수강하셨습니다 🎉</h3>
                    <div className="modal-close-btn" onClick={onCloseModal} />
                </view.ModalTitle>
                <view.Content>
                    <div className="modal-content-title">수고하셨습니다 😁</div>
                </view.Content>
            </view.ModalWrapper>
        </view.ModalSection>
    );
};

export default CourseClearModal;

export const useComponentStyle = () => {
    const theme = useTheme();
    return {
        view: {
            ModalSection: styled.div({
                position: "fixed",
                width: "100vw",
                height: "100vh",
                top: 0,
                left: 0,
                zIndex: "9999",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }),
            ModalWrapper: styled.div({
                overflowY: "visible",
                maxWidth: "40em",
                maxHeight: "inherit",
                height: "initial",
                backgroundColor: theme.colors.w,
                padding: "1.5em",
                position: "relative",
                "@media (max-width: 320px)": {
                    padding: "1.5em 1em 3em 1em",
                },
            }),
            ModalTitle: styled.div({
                width: "100%",
                height: "2%",
                display: "flex",
                alignItems: "center",
                marginBottom: "1.5em",
                "& > h3": {
                    width: "93%",
                    margin: 0,
                    textAlign: "center",
                    color: theme.colors.bearu_primary,
                },
                "& > .modal-close-btn": {
                    cursor: "pointer",
                    width: "1.5em",
                    height: "1.5em",
                    background: `url(${getImageUrl(
                        "image/common/ic_close_button.png"
                    )})center center/contain no-repeat`,
                },
            }),
            Content: styled.div({
                textAlign: "center",
                "& > .modal-content-title": {
                    fontSize: theme.font_size.f17,
                    fontWeight: "600",
                    "@media (max-width: 320px)": {
                        fontSize: theme.font_size.f16,
                    },
                },
                "& > .modal-content": {
                    fontSize: theme.font_size.f14,
                    "@media (max-width: 320px)": {
                        fontSize: theme.font_size.f13,
                    },
                },
            }),
        },
    };
};
